import {configureStore, createListenerMiddleware} from '@reduxjs/toolkit'
import './features/households/api';
import './features/onboarding/api';
import authReducer, {setUser} from './features/auth/state';
import mealPlanReducer, {persistenceMiddleware as mealPlanPersistenceMiddleware} from './features/meals/meal-plan/state';
import {baseApi} from "@/utils/api.js";

const logoutListener = createListenerMiddleware();

// Reset all API caches when the user logs out
logoutListener.startListening({
  actionCreator: setUser,
  effect: function (action, listenerApi) {
    if (action.payload == null) {
      listenerApi.dispatch(baseApi.util.resetApiState());
    }
  }
});

export default configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,    
    auth: authReducer,
    mealPlan: mealPlanReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()      
      .concat([
        logoutListener.middleware,
        mealPlanPersistenceMiddleware,
        baseApi.middleware,
      ]),
});
